export const MentorIcon = () => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_190_5328)'>
      <path
        d='M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z'
        fill='#C5DBFF'
      />
      <path
        d='M55.9563 29.557L37.0121 10.6127C34.7908 8.22812 31.6349 6.72563 28.1273 6.69009C21.3151 6.62118 15.6909 12.1821 15.686 18.9947C15.6835 22.4788 17.1284 25.6252 19.4521 27.8665C20.9043 29.2672 21.7561 31.1761 21.7561 33.1936V35.7227V36.06V42.41C21.7561 43.0213 22.0073 43.5735 22.4116 43.9703L24.0732 45.6039C24.1163 46.5124 24.4897 47.3379 25.0751 47.9631L32.7349 55.5994C45.4452 53.4344 55.2356 42.7044 55.9563 29.557Z'
        fill='#C5DBFF'
      />
      <path
        d='M28.2127 49.1456H27.7872C25.7419 49.1456 24.0684 47.4722 24.0684 45.4267V43.6724H31.9315V45.4267C31.9315 47.4722 30.2581 49.1456 28.2127 49.1456Z'
        fill='#2F37ED'
      />
      <path
        d='M31.932 43.6724V45.4267C31.932 47.472 30.2586 49.1455 28.2133 49.1455H28V43.6724H31.932Z'
        fill='#0E14A3'
      />
      <path
        d='M40.3143 19.0036C40.3143 12.2451 34.8696 6.75834 28.1273 6.69009C21.3151 6.62118 15.6909 12.1821 15.686 18.9947C15.6835 22.4788 17.1284 25.6252 19.4521 27.8665C20.9043 29.2672 21.7561 31.1761 21.7561 33.1936V36.0599C21.7561 37.4697 22.9096 38.6232 24.3194 38.6232H31.6809C33.0908 38.6232 34.2442 37.4697 34.2442 36.0599V33.2779C34.2442 31.2588 35.0397 29.3063 36.5005 27.9122C38.8502 25.67 40.3143 22.508 40.3143 19.0036Z'
        fill='#FFED93'
      />
      <path
        d='M40.3145 19.004C40.3145 22.5084 38.85 25.6704 36.5006 27.9126C35.0394 29.306 34.2442 31.2595 34.2442 33.2785V36.0599C34.2442 37.4698 33.0903 38.6237 31.6805 38.6237H28V6.68945C28.0416 6.68945 28.0842 6.69055 28.1269 6.69055C34.8698 6.75836 40.3145 12.2457 40.3145 19.004Z'
        fill='#FFC100'
      />
      <path
        d='M32.0565 44.5977H23.9436C22.7353 44.5977 21.7559 43.6182 21.7559 42.41V35.7227H34.2441V42.41C34.2441 43.6182 33.2646 44.5977 32.0565 44.5977Z'
        fill='#2F37ED'
      />
      <path
        d='M34.2442 35.7231V42.4103C34.2442 43.6178 33.2642 44.5978 32.0567 44.5978H28V35.7231H34.2442Z'
        fill='#0E14A3'
      />
    </g>
    <defs>
      <clipPath id='clip0_190_5328'>
        <rect width='56' height='56' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
